<template>
  <div>
    <router-view :orders="orders" @toggleShowDetail="toggleShowDetail"></router-view>
  </div>
</template>

<script>
  /* util */
  import {dd,store,app} from 'systems/imports'
  import Order from 'processor/Order'

  /** @see page_subPages_MyPage_Order_Download child page */
  /** @see page_subPages_MyPage_Order_History child page */

  /** @name page_subPages_MyPage_Order */
  export default {
    name:"",
    components: {
    },
    data () {
      return {
        orders:[],
      }
    },
    mounted(){
      Order.getOrders()
        .then((res) => {
          if (res.status === "ng") {
            this.apiErrorI18nKeyByCart = res.apiErrorI18nKey
            return
          }
          this.orders = app.make("_").map(res.data.orders,(order)=>{
            order.isShowDetail=false
            return order
          })
        })
    },
    methods:{
      toggleShowDetail(targetOrder){
        //dd("toggleShowDetail",targetOrder.id)

        let order = app.make("_").find(this.orders,(order)=>{
          return order.id===targetOrder.id
        })
        order.isShowDetail=!order.isShowDetail
      }

    }
  }
</script>


<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// Order.vue?121fa4fb